import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./RecognitionTab.module.css";

export default function RecognitionTab() {
  const [members, setMembers] = useState<any[]>([]);

  const API = process.env.REACT_APP_API_URL || "http://localhost:8080";

  const RECOGNITION_OPTIONS = [
    "Crorepati Giver",
    "Green Pin",
    "Gold Pin",
    "Leadership Pin",
  ];

  // ✅ Normalize backend spelling issues
  const normalize = (r: string) => {
    if (!r) return r;
    const low = r.toLowerCase();
    if (low.includes("corore") || low.includes("crore")) {
      return "Crorepati Giver";
    }
    return r;
  };

  const load = () => {
    axios
      .get(`${API}/api/members`)
      .then((r) => {
        const fixed = r.data.data.map((m: any) => ({
          ...m,
          recognition: Array.isArray(m.recognition)
            ? m.recognition.map(normalize)
            : [],
        }));
        setMembers(fixed);
      })
      .catch((error) => {
        console.log("error while getting Members detail", error);
      });
  };

  useEffect(() => load(), []);

  // ✅ Toggle recognition — sends **array** to backend
  const toggleRecognition = async (memberId: string, item: string) => {
    const token = localStorage.getItem("bni_token");

    const member = members.find((m) => m._id === memberId);
    if (!member) return;

    const updated = member.recognition.includes(item)
      ? member.recognition.filter((r: string) => r !== item)
      : [...member.recognition, item];

    try {
      await axios.post(
        `${API}/api/admin/recognize/${memberId}`,
        { recognition: updated },
        { headers: { Authorization: "Bearer " + token } }
      );

      load();
    } catch (error) {
      console.log("error while uodating Member's Recognition", error);
    }
  };

  return (
    <div>
      <h2 className={styles.title}>Member Recognition</h2>

      {members.map((m) => (
        <div key={m._id} className={styles.card}>
          <div className={styles.info}>
            <h3>{m.name}</h3>
            <p>{m.orgName}</p>
          </div>

          <div className={styles.badges}>
            {RECOGNITION_OPTIONS.map((item) => (
              <label key={item} className={styles.badgeCheck}>
                <input
                  type="checkbox"
                  checked={m.recognition.includes(item)}
                  onChange={() => toggleRecognition(m._id, item)}
                />
                <span>{item}</span>
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
